import React, { useState } from 'react';
import { LegalModal } from './LegalModal';
export function Footer() {
  const [modalType, setModalType] = useState<'privacy' | 'terms' | null>(null);
  return <>
      <footer className="py-8 bg-white border-t border-[#E8EDE6]" data-id="element-51">
        <div className="container mx-auto px-6 max-w-4xl flex flex-col items-center gap-4" data-id="element-52">
          <div className="flex items-center gap-6" data-id="element-53">
            <button onClick={() => setModalType('privacy')} className="text-sm text-[#6B6560] hover:text-[#4A6741] transition-colors duration-200 underline underline-offset-2 decoration-[#E8EDE6] hover:decoration-[#4A6741]" data-id="element-54">
              Política de Privacidad
            </button>
            <span className="text-[#E8EDE6]" data-id="element-55">|</span>
            <button onClick={() => setModalType('terms')} className="text-sm text-[#6B6560] hover:text-[#4A6741] transition-colors duration-200 underline underline-offset-2 decoration-[#E8EDE6] hover:decoration-[#4A6741]" data-id="element-56">
              Términos y Condiciones
            </button>
          </div>
          <p className="text-sm text-[#6B6560]" data-id="element-57">
            © {new Date().getFullYear()} Protocolo Vientre Plano 50+. Todos los
            derechos reservados.
          </p>
        </div>
      </footer>

      <LegalModal isOpen={modalType !== null} onClose={() => setModalType(null)} type={modalType ?? 'privacy'} data-id="element-58" />
    </>;
}